<template>
  <FigmaCatalogDetail :kind="kind" />
</template>

<script setup>
/* eslint-disable no-undef */
import FigmaCatalogDetail from './FigmaCatalogDetailV2.vue'

defineProps({
  kind: { type: String, default: 'accommodation' },
})
</script>
